import React from 'react';
import PropTypes from 'prop-types';

import Link from '../../../../library/link/link';
import { AngleRightLightIcon } from '../../../../shared/icons/icons';

import styles from './cms-shopping-guide.scss';

function CmsShoppingGuide(props) {
  const { sections } = props;
  const [leftPanel, rightPanel] = sections || [];

  return (
    <div className={styles['container']}>
      {leftPanel && (
        <div className={styles['panel']}>
          <img
            alt={leftPanel?.image?.altText}
            className={styles['left-image']}
            src={leftPanel?.image?.url}
          />
          <div className={styles['left-content']}>
            <h3 className={styles['heading']}>{leftPanel?.heading}</h3>
            <p className={styles['info']}>{leftPanel?.info}</p>
            {leftPanel?.link && (
              <Link className={styles['link']} to={leftPanel.link.href}>
                {leftPanel.link.text}
                <AngleRightLightIcon className={styles['icon']} />
              </Link>
            )}
          </div>
        </div>
      )}
      {rightPanel && (
        <div className={styles['panel']}>
          <img
            alt={rightPanel?.image?.altText}
            className={styles['right-image']}
            src={rightPanel?.image?.url}
          />
          <div className={styles['right-content']}>
            <h3 className={styles['heading']}>{rightPanel?.heading}</h3>
            <p className={styles['info']}>{rightPanel?.info}</p>
            {rightPanel?.link && (
              <Link className={styles['link']} to={rightPanel.link.href}>
                {rightPanel.link.text}
                <AngleRightLightIcon className={styles['icon']} />
              </Link>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

CmsShoppingGuide.propTypes = {
  sections: PropTypes.array
};

export default CmsShoppingGuide;
